/* ColdGear header: mega panels, search band, drawer levels, cart proxy */
(function () {
  if (window.__cgHeader) return;
  window.__cgHeader = true;
  var desk = window.matchMedia('(min-width: 990px)');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var closeTimer;

  function hdr() { return document.querySelector('[data-cg-hdr]'); }
  function scrim(on) { var s = document.querySelector('[data-cg-scrim]'); if (s) s.hidden = !on; }

  function closePanels() {
    var h = hdr(); if (!h) return;
    h.querySelectorAll('[data-cg-mega]').forEach(function (p) { p.hidden = true; });
    h.querySelectorAll('[data-cg-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    scrim(false);
  }
  function warm(scope) {
    (scope || document).querySelectorAll('.cg-mega img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }
  /* desktop: fetch menu images once the page is idle so panels open instantly */
  window.addEventListener('load', function () {
    if (!desk.matches) {
      /* phones: warm the drawer images so the menu opens with pictures */
      (window.requestIdleCallback || function (f) { setTimeout(f, 2000); })(function () {
        var d = drawer(); if (d) d.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
      });
      return;
    }
    (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { warm(); });
  });
  function openPanel(key) {
    var h = hdr(); if (!h) return;
    warm(h.querySelector('[data-cg-mega="' + key + '"]'));
    closeSearch();
    h.querySelectorAll('[data-cg-mega]').forEach(function (p) { p.hidden = p.getAttribute('data-cg-mega') !== key; });
    h.querySelectorAll('[data-cg-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-cg-trigger') === key ? 'true' : 'false'); });
    scrim(true);
  }
  function openSearch() {
    closePanels();
    var b = document.querySelector('[data-cg-search]'); if (!b) return;
    b.hidden = false;
    document.querySelectorAll('[data-cg-search-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    var i = b.querySelector('input[type=search]'); if (i) setTimeout(function () { i.focus(); }, 30);
  }
  function closeSearch() {
    var b = document.querySelector('[data-cg-search]'); if (!b || b.hidden) return;
    b.hidden = true;
    document.querySelectorAll('[data-cg-search-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  /* drawer */
  function drawer() { return document.querySelector('[data-cg-drawer]'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    goLevel('root', true);
    d.hidden = false;
    document.documentElement.classList.add('cg-hdr-lock');
    document.querySelectorAll('[data-cg-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer() {
    var d = drawer(); if (!d || d.hidden) return;
    d.hidden = true;
    document.documentElement.classList.remove('cg-hdr-lock');
    document.querySelectorAll('[data-cg-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function goLevel(key, instant) {
    var d = drawer(); if (!d) return;
    d.querySelectorAll('[data-cg-level]').forEach(function (l) {
      var on = l.getAttribute('data-cg-level') === key;
      l.hidden = !on;
      l.classList.remove('is-enter', 'is-back');
      if (on && !instant) l.classList.add(key === 'root' ? 'is-back' : 'is-enter');
      if (on) { var b = l.querySelector('.cg-drawer__body'); if (b) b.scrollTop = 0; }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cg-trigger]');
    if (t) {
      var key = t.getAttribute('data-cg-trigger');
      if (t.getAttribute('aria-expanded') === 'true') closePanels(); else openPanel(key);
      return;
    }
    if (e.target.closest('[data-cg-search-toggle]')) {
      var b = document.querySelector('[data-cg-search]');
      if (e.target.closest('[data-cg-drawer]')) closeDrawer();
      if (b && b.hidden) openSearch(); else closeSearch();
      return;
    }
    if (e.target.closest('[data-cg-search-close]')) { closeSearch(); return; }
    if (e.target.closest('[data-cg-scrim]')) { closePanels(); return; }
    if (e.target.closest('[data-cg-drawer-open]')) { openDrawer(); return; }
    var go = e.target.closest('[data-cg-go]');
    if (go) { goLevel(go.getAttribute('data-cg-go')); return; }
    if (e.target.closest('[data-cg-drawer-close]')) { closeDrawer(); return; }

    /* cart: hand the click to the theme's cart drawer (it listens on #cart-icon-bubble) */
    var cart = e.target.closest('[data-cg-cart]');
    if (cart && document.querySelector('cart-drawer')) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && !bubble.contains(e.target)) { e.preventDefault(); closeDrawer(); bubble.click(); }
      return;
    }
    /* click outside an open panel closes it */
    var h = hdr();
    if (h && !h.contains(e.target)) { closePanels(); closeSearch(); }
  });

  /* hover intent on desktop */
  document.addEventListener('pointerover', function (e) {
    if (!hoverable.matches || !desk.matches) return;
    var t = e.target.closest('[data-cg-trigger]');
    if (t) { clearTimeout(closeTimer); openPanel(t.getAttribute('data-cg-trigger')); return; }
    if (e.target.closest('.cg-mega')) { clearTimeout(closeTimer); return; }
    if (e.target.closest('.cg-hdr__link, .cg-hdr__logo, .cg-hdr__utils')) { closePanels(); }
  });
  document.addEventListener('pointerout', function (e) {
    if (!hoverable.matches || !desk.matches) return;
    var from = e.target.closest('[data-cg-trigger], .cg-mega');
    var to = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-cg-trigger], .cg-mega');
    if (from && !to) { clearTimeout(closeTimer); closeTimer = setTimeout(closePanels, 220); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closePanels(); closeSearch(); closeDrawer();
  });
  desk.addEventListener && desk.addEventListener('change', function () { closePanels(); closeDrawer(); });

  /* keep the mobile cart count in sync with the bubble the theme re-renders */
  function mirror() {
    var src = document.getElementById('cart-icon-bubble');
    document.querySelectorAll('[data-cg-bubble-mirror]').forEach(function (m) { if (src) m.innerHTML = src.innerHTML; });
  }
  function watchBubble() {
    var src = document.getElementById('cart-icon-bubble');
    if (src && 'MutationObserver' in window) new MutationObserver(mirror).observe(src, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBubble); else watchBubble();
  document.addEventListener('shopify:section:load', function () { watchBubble(); mirror(); });
})();
